<template>
  <div>
    <!--<div v-if="context.state === API_STATES.error">
      <strong>Oops, da ist wohl etwas schief gelaufen.</strong>
    </div>-->

    <!--div v-else-if="showPlaceholder" class="teaser-container">
      <dpc-teaser-placeholder
        v-for="index in context.requestParams.limit || 9"
        :key="`teaser-placeholder-${index}`"
      ></dpc-teaser-placeholder>
    </div-->

    <suspense>
      <dpc-calendar-vertical v-if="teaserList.length" :teaser-list="teaserList">
        <slot />
      </dpc-calendar-vertical>

      <dpc-p-calendar-vertical v-else-if="isFetching" />

      <template #fallback>
        <dpc-p-calendar-vertical />
      </template>
    </suspense>
  </div>
</template>
<script setup>
import { computed, inject, readonly } from 'vue';
const responseHistory = inject('api/responseHistory', readonly([]));

const teaserList = computed(() => {
  return responseHistory.value.reduce((teaserList, response) => {
    if (response.teaser) teaserList.push(...response.teaser);
    return teaserList;
  }, []);
});

const isFetching = inject('api/isFetching');
</script>
